import { IAppState } from '../../../../shared/common/state';
import { PROFESSIONAL_SEARCH_ENTRY_POINTS } from '../../../../shared/constants/profSearchExperiment';
import { selectIsUserAgent } from './selectIsUserAgent';

export const selectIsProfessionalSearchPromoVisible = (state: IAppState) => {
  const { abUseExperiments } = state;

  const isAgent = selectIsUserAgent(state);

  const experiment = abUseExperiments.find(exp => exp.experimentName === PROFESSIONAL_SEARCH_ENTRY_POINTS);
  const inExperiment = Boolean(experiment && experiment.groupName !== 'control');

  return isAgent && inExperiment;
};
